import {useState} from "react"

const TYPE__SUCCESS = 1
const TYPE__ERROR = 2
const TYPE__PROMPT = 3
const INIT_STATE = {show: false, type: 0, message: "", callbackYes: null, callbackNo: null}

export const useMessage = () => {
    const [state, setState] = useState(INIT_STATE)

    const confirm = () => {
        if (state.callbackYes) {
            state.callbackYes()
        }
        setState(prevState => ({...prevState, show: false, callbackYes: null, callbackNo: null}))
    }

    const close = () => {
        if (state.callbackNo) {
            state.callbackNo()
        }
        setState(prevState => ({...prevState, show: false, callbackYes: null, callbackNo: null}))
    }

    const hasMessage = () => {
        return state.show && state.type && state.message
    }

    const getMessage = () => {
        return state.message
    }

    const setMessage = (type, message, callbackYes = null, callbackNo = null) => {
        setState({show: true, type, message, callbackYes, callbackNo})
    }

    const isSuccess = () => {
        return state.type === TYPE__SUCCESS
    }

    const showSuccess = (message) => {
        setMessage(TYPE__SUCCESS, message)
    }

    const isError = () => {
        return state.type === TYPE__ERROR
    }

    const showError = (message) => {
        setMessage(TYPE__ERROR, message)
    }

    const isPrompt = () => {
        return state.type === TYPE__PROMPT
    }

    const showPrompt = (message, callbackYes, callbackNo = null) => {
        setMessage(TYPE__PROMPT, message, callbackYes, callbackNo)
    }

    return {
        confirm, close,
        hasMessage, getMessage,
        isSuccess, showSuccess,
        isError, showError,
        isPrompt, showPrompt,
    }
}
